<template>
  <div class="layout greet_warp">
    <div class="greet_head">
      <div class="greet_head_top">
        <div class="user_info">
          <div class="user_left">
            <div class="user_img_div">
              <img
                :src="info.avatarUrl?info.avatarUrl:'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=188149577,2949073731&fm=26&gp=0.jpg'"
              />
              <div class="user_role">
                <span v-if="info.userRole === 2">专业买家</span>
                <span v-if="info.userRole === 3">行业名人</span>
                <span v-if="info.userRole === 4">展商</span>
              </div>
            </div>
            <div class="user_info_top" :class="{tag_br:isbr}">
              <p class="user_name van-ellipsis">
                {{info.name?info.name:'姓名'}}
                <span>{{info.jobTitle?info.jobTitle:'称谓'}}</span>
              </p>
              <p class="company_name" v-if="info.company">{{info.company}}</p>
              <div class="interest"  v-if="info.category">
                <div v-for="(item,index) in getCateList(info.category)" :key="index">
                 <span>{{item}}</span>
                </div>
              </div>
            </div>
          </div>
          <p
            class="uset_text"
          >简介：{{info.introduction}}</p>
          <div class="sign">
            <p >供需：<p v-if="info.business" v-html="$service.replaceSpeace(getBuContetn(info.business))">
            <div class="sign_img" v-if="info.business" >
              <img v-for="(item,index) in getBuImgList(info.business)" @click="viewImg(getBuImgList(info.business),index)" :key="index"
                :src="item"
                   v-load="'oMyBus'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="greet_content">
      <van-tabs
        class="topic_content_nav"
        @change="topicChange"
        animated
        lazy-render
        line-height="0.03rem"
        line-width="1.38rem"
        color="#f85b0f"
        title-inactive-color="#fff"
        title-active-color="#f85b0f"
        v-model="activeName"
        sticky
        swipeable
      >
        <van-tab name="launchTopic">
          <template #title>
            <div class="con_nav_title">
              <p class="title_text">发起的话题</p>
            </div>
          </template>
          <!-- <van-list
              class="topic_con"
              v-model="launchLoading"
              :finished="launchFinished"
              finished-text="没有更多了"
              @load="launchLoad"
            >
              <div class="topic_item" v-for="(item, index) in launchList" :key="index">
                <img src="http://img1.imgtn.bdimg.com/it/u=1058003923,4159834876&fm=26&gp=0.jpg">
                <div class="topic_info">
                  <p class="topic_title">/#话题/现在线上会展为什么会这么火爆，它哪里吸引人？现在线上会展为什么会这么火爆，它哪里吸引人？</p>
                  <p class="topic_data">参与人数：1567<span></span>留言数量：1567</p>
                </div>
              </div>
          </van-list>-->
          <div class="no_content" v-if="!launchList.length">暂无任何消息</div>
        </van-tab>
        <van-tab name="particTopic">
          <template #title>
            <div class="con_nav_title">
              <p class="title_text">参与的话题</p>
            </div>
          </template>
          <!-- <van-list
              class="topic_con"
              v-model="particLoading"
              :finished="particFinished"
              finished-text="没有更多了"
              @load="particLoad"
            >
              <div class="topic_item" v-for="(item, index) in particList" :key="index">
                <img src="http://img1.imgtn.bdimg.com/it/u=1058003923,4159834876&fm=26&gp=0.jpg">
                <div class="topic_info">
                  <p class="topic_title">/#话题/现在线上会展为什么会这么火爆，它哪里吸引人？现在线上会展为什么会这么火爆，它哪里吸引人？</p>
                  <p class="topic_data">参与人数：1567<span></span>留言数量：1567</p>
                </div>
              </div>
          </van-list>-->
          <div class="no_content" v-if="!launchList.length">暂无任何消息</div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- <van-button @click="greetClick" class="greetBtn" color="#f85b0f" block>打招呼</van-button> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { isMoment } from 'moment';
import {ImagePreview} from "vant";
export default {
  name: "greet",
  components: {},
  data() {
    return {
      activeName: "launchTopic",
      info:{},              //专业买家详情信息
      launchLoading: false, //发起的话题动态加载状态
      launchFinished: false, //发起的话题加载是否完成状态
      launchList: [], //发起的话题列表
      isbr:false,
      particLoading: false, //参与的话题动态加载状态
      particFinished: false, //参与的话题加载是否完成状态
      particList: [] //参与的话题加载状态
    };
  },
  computed: {
    ...mapGetters({
      user: "getUserInfo"
    }),
    inMemberId() {
      return this.$route.query.inMemberId;
    }
  },
  created(){
    this.getInfo();
  },
  methods: {
    ...mapActions({
      getMemberInfo:"connection/getMemberInfo"
    }),
    //得到供需内容
    getBuContetn(str){
      return JSON.parse(str).content
    },
    //得到供需图片List
    getBuImgList(str){
      return JSON.parse(str).imgList
    },
    //预览图片
    viewImg(imgList,index){
      ImagePreview({images: imgList, startPosition: index});
    },
    getCateList(str){
      let option=JSON.parse(str);
      let cateList=[];
      option.forEach(el => {
          el.Lists.forEach(model=>{
            cateList.push(model.Value);
          })
      });
      this.getElHeight();
      return cateList
    },
    //获取元素高度
    getElHeight(){
      this.$nextTick(()=>{
        let h=$('.interest').height()
        if(h>30){
          this.isbr=true;
        }
      })
    },
    async getInfo(){
      let data=await this.getMemberInfo(this.inMemberId);
      if(data){
        this.info=data.detail;
      }
      else{
        this.info={};
        this.$toast.fail('获取信息失败');
      } 
    },
    //发起的话题数据加载
    launchLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.launchList.push(this.launchList.length + 1);
        }

        // 加载状态结束
        this.launchLoading = false;

        // 数据全部加载完成
        if (this.launchList.length >= 3) {
          this.launchFinished = true;
        }
      }, 1000);
    },
    //参与的话题数据加载
    particLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.particList.push(this.particList.length + 1);
        }

        // 加载状态结束
        this.particLoading = false;

        // 数据全部加载完成
        if (this.particList.length >= 3) {
          this.particFinished = true;
        }
      }, 1000);
    },
    //tab改变
    topicChange(data) {
      return;
      console.log(data, "tab改变");
      if (data == "launchTopic") {
        // this.launchLoading = true;
        // this.launchFinished = false;
        this.launchList = [];
        // this.launchLoad();
      } else {
        // this.particLoading = true;
        // this.particFinished = false;
        this.particList = [];
        // this.particLoad();
      }
    },
    //跳转打招呼页面
    greetClick() {}
  }
};
</script>
<style lang="scss">
.topic_content_nav {
  .van-sticky {
    background: #131825;
    padding-bottom: 0.15rem;
  }
  .van-tabs__wrap {
    height: 0.91rem;
    padding: 0 0.24rem;
    &::after {
      border-top: none;
    }
  }
  .van-tabs__nav {
    background: transparent;
    .con_nav_title {
      text-align: center;
      display: flex;
      flex-direction: column;
      line-height: 0.32rem;
      height: 100%;
      justify-content: center;
      .title_text {
        // letter-spacing: 1px;
      }
    }
  }
  .van-list__finished-text,
  .van-list__loading {
    width: 100%;
    line-height: 0.3rem;
    margin-bottom: 0.15rem;
    font-size: 0.24rem;
  }
  .van-tabs__content {
    min-height: 3rem;
  }
  .no_content {
    text-align: center;
    color: #fff;
    margin-top: 1.35rem;
  }
}
</style>
<style lang="scss" scoped>
.greet_warp {
  background: #131825;
}
.greet_head {
  width: 100%;
  padding: 0.2rem 0.24rem 0.33rem;
  .greet_head_top {
    color: #fff;
    .user_info {
      .user_left {
        display: flex;
        margin-bottom: 0.2rem;
        .user_img_div {
          width: 1.1rem;
          height: 1.26rem;
          margin-right: 0.19rem;
          position: relative;
          text-align: center;
          img {
            width: 1.1rem;
            height: 1.1rem;
            border-radius: 50%;
            border: 0.03rem solid #fff;
          }
          .user_role{
            position: absolute;
            display: flex;
            justify-items: center;
            align-items: center;
            text-align: center;
            bottom: 0;
            left: 0.05rem;
            height: 0.32rem;
            border-radius: 0.03rem;
            width: 1rem;
            background: #f85b0f;
            color: #fffefe;
            span {
              font-size: 0.2rem;
              width: 100%;
            }
          }
        }
        .user_info_top {
          width: calc(100% - 1.29rem);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p{
            line-height: 1.1;
          }
          &.no_comp {
            justify-content: center;
          }
          &.comm_user {
            justify-content: space-between;   
            padding-top: 0.35rem;
            .reg_btn {
              color: #f85b0f;
              font-size: 0.2rem;
            }
          }
          .user_name {
            font-size: 0.3rem;
            span {
              font-size: 0.22rem;
              margin-left: 0.19rem;
            }
          }
          .company_name {
            font-size: 0.22rem;
            line-height: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.tag_br{
            justify-content:flex-start;
            .user_name{
              margin-bottom: 0.05rem;
            }
            .company_name{
              margin-bottom: 0.13rem;
            }
            .interest{
              margin-bottom: -0.1rem;
              div{
                margin-bottom: 0.1rem;
              } 
            }
          }
          .interest {
            display: flex;
            flex-wrap: wrap;
            div{
              margin-right: 0.1rem;
              display: flex;
              justify-items: center;
              align-items: center;
              text-align: center;
              height: 0.32rem;
              background: #333d56;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              border-radius: 0.03rem;
              padding: 0 0.11rem;
              span{
                font-size: 0.2rem;  
              }
            }
          }
        }
      }
      .sign {
        position: relative;
        p {
          margin-top: 0.23rem;
          word-wrap:break-word;
          word-break:break-all;
          text-align: justify;
        }
        .sign_img {
          display: flex;
          img {
            width: 1.1rem;
            height: 1.1rem;
            margin-right: 0.1rem;
            margin-top: 0.15rem;
            display: block;
            // object-fit: cover;
          }
        }
      }
      .uset_text {
        line-height: 0.3rem;
        color: #bfbfbf;
        padding-bottom: 0.2rem;
        border-bottom: 1px solid #415374;
      }
    }
  }
}
.greet_content {
  background: #131825;
  //产品内容
  .topic_con {
    padding: 0 0.24rem;
    .topic_item {
      padding: 0.2rem;
      display: flex;
      background: #1d2435;
      color: #fff;
      margin-bottom: 0.2rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 0.03rem;
        margin-right: 0.2rem;
        flex-shrink: 0;
      }
      .topic_info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0.2rem 0;
        overflow: hidden;
        .topic_title {
          white-space: initial;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .topic_data {
          font-size: 0.2rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          span {
            margin-right: 0.4rem;
          }
        }
      }
    }
  }
}
.greetBtn {
  height: 0.98rem;
  line-height: 0.98rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0;
  span {
    font-size: 0.36rem;
  }
}
</style>